const seo = {
  TITLE: 'Utkarsh Patel',
  URL: 'http://utkarsh-patel.com',
  IMAGE: 'https://imgur.com/7tKKuuF',
  DESCRIPTION: `Utkarsh's Portfolio`
};

export default seo;


// WEBPACK FOOTER //
// ./src/data/seo.js